import {action, computed, makeObservable, observable} from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import successToast from "../../../components/toast/SuccessToast";

export default class PaymentReminderFeature {

    constructor(application) {
        this._application = application;
        this._isOpen = false;
        this._taxpayerIdentificationNumber = null;
        this._subject = '';
        this._receivers = [];
        this._blindCopyReceivers = [];
        this._overdueInvoices = [];
        this._totalOverdue = null;
        this._paymentTrackRecord = null;
        this._message = '';
        this._errorMessage = '';
        this._isSending = false;
        this._hasPreview = false;

        makeObservable(this, {
            _isOpen: observable,
            _subject: observable,
            _receivers: observable,
            _blindCopyReceivers: observable,
            _overdueInvoices: observable,
            _totalOverdue: observable,
            _paymentTrackRecord: observable,
            paymentTrackRecord: computed,
            _message: observable,
            _errorMessage: observable,
            _isSending: observable,
            _hasPreview: observable,
            hasPreview: computed,
            isOpen: computed,
            subject: computed,
            receivers: computed,
            blindCopyReceivers: computed,
            overdueInvoices: computed,
            totalOverdue: computed,
            message: computed,
            errorMessage: computed,
            isSending: computed,
            canSend: computed,
            open: action,
            close: action,
            setMessage: action,
        })
    }

    get isOpen() {
        return this._isOpen;
    }

    get subject() {
        return this._subject;
    }

    get receivers() {
        return this._receivers;
    }

    get blindCopyReceivers() {
        return this._blindCopyReceivers;
    }

    get overdueInvoices() {
        return this._overdueInvoices;
    }

    get totalOverdue() {
        return this._totalOverdue;
    }

    get paymentTrackRecord() {
        return this._paymentTrackRecord;
    }

    get message() {
        return this._message;
    }

    get errorMessage() {
        return this._errorMessage;
    }

    get isSending() {
        return this._isSending;
    }

    get hasPreview() {
        return this._hasPreview;
    }

    get canSend() {
        return this._message.trim().length > 0 && !this._isSending;
    }

    setMessage(message) {
        this._message = message;
    }

    async open(taxpayerIdentificationNumber) {
        this._taxpayerIdentificationNumber = taxpayerIdentificationNumber;
        this._errorMessage = '';
        this._hasPreview = false;
        this._subject = '';
        this._receivers = [];
        this._blindCopyReceivers = [];
        this._overdueInvoices = [];
        this._totalOverdue = null;
        this._paymentTrackRecord = null;
        this._message = '';
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this._subject = response.subject();
                this._receivers = response.receivers();
                this._blindCopyReceivers = response.blindCopyReceivers();
                this._overdueInvoices = response.overdueInvoices();
                this._totalOverdue = response.totalOverdue();
                this._paymentTrackRecord = response.paymentTrackRecord();
                this._message = response.message();
                this._hasPreview = true;
                this._isOpen = true;
            },
            handlesError: (response) => {
                this._errorMessage = this._errorMessageFor(response, 'No se pudo obtener la vista previa del recordatorio de pago');
                this._isOpen = true;
            }
        });
        return this._application.apiClient().getPaymentReminderPreview(taxpayerIdentificationNumber, responseHandler);
    }

    _errorMessageFor(response, unexpectedErrorMessage) {
        const errorMessagesByCode = {
            'customer_without_collections_email_error': 'El cliente no tiene mail de cobranzas cargado. No se puede enviar el recordatorio.',
            'customer_without_overdue_invoices_error': 'El cliente no tiene facturas vencidas. No hay nada que recordarle.',
            'blank_payment_reminder_message_error': 'El mensaje del recordatorio no puede estar vacío.',
        };
        const knownError = response.errors().find(error => error.code in errorMessagesByCode);
        return knownError ? errorMessagesByCode[knownError.code] : unexpectedErrorMessage;
    }

    close() {
        this._isOpen = false;
    }

    async send() {
        this._isSending = true;
        this._errorMessage = '';
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: () => {
                this._isSending = false;
                this._isOpen = false;
                successToast('Recordatorio enviado correctamente');
            },
            handlesError: (response) => {
                this._isSending = false;
                this._errorMessage = this._errorMessageFor(response, 'No se pudo enviar el recordatorio de pago');
            }
        });
        return this._application.apiClient().sendPaymentReminder(
            this._taxpayerIdentificationNumber, this._message, responseHandler);
    }

}
